import * as path from 'path-browserify';

export function webHookMessage(message: string, userId: number): string {
  return `{ "message": "${message}", "userId": ${userId} }`;
}

export function checkIfTrue(value: string | number | undefined | null): boolean {
  if (!value) {
    return false;
  }
  return value === 'TRUE' || value === 'true' || value === 1;
}

export function isSame(left: any, right: any): boolean {
  try {
    return JSON.stringify(left) === JSON.stringify(right);
  } catch (e) {
    return false;
  }
}

export function removeEmpty(obj: Record<any, any>) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

export function pathJoin(parts: string[], separator = '/') {
  const replace = new RegExp(separator + '{1,}', 'g');
  return parts.join(separator).replace(replace, separator);
}

export function wait(milliseconds) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export function removeExtensionFromFileName(_str): string {
  return path.parse(_str).name;
}
